export const STORE_ORDERS_WIDGET_ID = 'paid-ads.store-orders-widget';
export const BI_VIEW_ID = 'PAID_ADS_STORE_ORDERS_WIDGET';
export const WIDGET_BUNDLE_FILE = 'store-orders-widget';
export const PAID_ADS_APP_ID = '9bead16f-1c73-4cda-b6c4-28cff46988db';
export const WIDGET_DISMISSED_KEY = 'widget-dismissed';
